import { hydrate } from '@ubo/losse-sjedel'

hydrate()

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
  })
}
